import React, { useEffect } from "react";
import { toast } from "react-toastify";
import closeIcon from "assets/Icon_Toast_Cross.png";

type ToastMessageProps = {
  title: string;
  text: string;
  bSuccess: boolean;
};

const ToastMessage: React.FC<ToastMessageProps> = ({
  title,
  text,
  bSuccess,
}) => {
  const toastMessage = () =>
    toast(
      <div className={`Content ${bSuccess ? "Success" : "Error"}`}>
        <div className="Title">{title}</div>

        <div className="Text">{text}</div>

        <div className="CloseButton" onClick={() => toast.dismiss()}>
          <img src={closeIcon} alt="close" />
        </div>
      </div>,
      {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
        pauseOnHover: false,
        draggable: false,
      }
    );

  useEffect(() => {
    toastMessage();
  }, []);

  return <></>;
};

export default ToastMessage;
